import { fetchMotherNatureReport } from '../data/mother-nature';

/**
 * Renders the seismic energy panel into the given container.
 */
export function renderMotherNatureCard(container: HTMLElement): void {
  const panel = document.createElement('div');
  panel.className = 'panel';
  panel.innerHTML = `
    <div class="threat-header">
      <span class="threat-title">Seismic energy</span>
      <span class="threat-emoji" aria-hidden="true">🌍</span>
    </div>
    <p class="panel-content threat-subtext">M4.5+ earthquakes worldwide, past 7 days. Source: USGS.</p>
    <div class="threat-label-row"><span>Activity level</span><strong>Loading…</strong></div>
    <div class="threat-meter" aria-hidden="true"><div class="threat-meter-fill level-2"></div></div>
    <p class="panel-content" id="mother-summary">Loading USGS feed…</p>
    <p class="threat-stats" id="mother-stats"></p>
    <p class="disclaimer-astro">Not a safety alert. For awareness only — follow local emergency guidance.</p>
  `;
  container.appendChild(panel);

  fetchMotherNatureReport().then((r) => {
    const summary = panel.querySelector('#mother-summary');
    const stats = panel.querySelector('#mother-stats');
    const labelRow = panel.querySelector('.threat-label-row strong');
    const fill = panel.querySelector('.threat-meter-fill') as HTMLElement;
    const emoji = panel.querySelector('.threat-emoji');
    if (summary) summary.textContent = r.summary;
    if (labelRow)
      labelRow.textContent = `Level ${r.level}/5 — ${r.label}`;
    if (fill) {
      fill.className = `threat-meter-fill level-${r.level}`;
      fill.style.width = '';
    }
    if (emoji) emoji.textContent = r.emoji;
    if (stats) {
      const parts = [
        `${r.quakeCount45} quakes M4.5+ (7 days)`,
        r.maxMagnitude != null ? `largest M${r.maxMagnitude}` : null,
        r.error ? `(${r.error})` : null,
      ].filter(Boolean);
      stats.textContent = parts.join(' · ');
    }
  });
}
